import { useDrawdownRepaymentSchedule } from '@api/lendingAPI/lapiHooks';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { Text, Tooltip } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { TUseRCFWithdrawFunds } from './useRCFWithdrawFunds';
import { isSelectedAmountValidForAccessPeriod } from '../../../ui/ChooseAmountInputWithSlider/isSelectedAmountValid';

export const NextRepayment = ({
    accessPeriod,
    selectedAmount
}: {
    accessPeriod: TUseRCFWithdrawFunds['formalOfferAccessPeriod'];
    selectedAmount: number;
}) => {
    const { data } = useDrawdownRepaymentSchedule({
        offerId: accessPeriod.offer_id,
        drawdownAmount: selectedAmount,
        enabled: isSelectedAmountValidForAccessPeriod(
            selectedAmount,
            accessPeriod
        ),
        suspense: true
    });

    const nextRepaymentAmount =
        data?.summary.simplified_schedule!.next_repayment!.amount;

    return (
        <div className="flex items-start justify-between">
            <div className="flex items-center gap-s">
                <Text className="font-reg">
                    <FormattedMessage
                        id="_.outstanding_view.rcf_next_monthly_instalment"
                        defaultMessage="Next monthly instalment"
                    />
                </Text>
                <Tooltip
                    // @ts-expect-error
                    content={
                        <FormattedMessage
                            id="_.outstanding_view.rcf_withdrawal_fees_tooltip"
                            defaultMessage="Consists of the interest accrued on the outstanding loan amount."
                        />
                    }
                />
            </div>
            <div className="flex flex-col items-end">
                <Text className="text-l font-bold">
                    {nextRepaymentAmount ? (
                        <FormattedCurrency value={nextRepaymentAmount} />
                    ) : (
                        '--.-- €'
                    )}
                </Text>
                <Text className="text-s font-reg">
                    <FormattedMessage
                        id="_.outstanding_view.rcf_next_monthly_instalment_estimated"
                        defaultMessage="(estimated)"
                    />
                </Text>
            </div>
        </div>
    );
};
